import React from 'react';
import ColoredValue from './ColoredValue';

const PlusMinusColoredValue = ({
  className = '',
  value = '',
  children = '',
}) => {
  let color = '';

  if (value || value === 0) {
    if (value < 0) {
      color = 'red';
    } else {
      color = 'green';
    }
  }

  return (
    <ColoredValue className={`${className}`} color={color}>
      {children}
    </ColoredValue>
  );
};

export default PlusMinusColoredValue;
